module.exports = __webpack_public_path__ + "bin/647b062da5e6704c16087d26517cb7a7.png";